/**
 * Ajustes → Vocabulario: nombres propios, siglas y jerga que la transcripción
 * debe reconocer. Se envían al proveedor junto con los temas a seguir.
 */
import { useEffect, useState } from 'react'
import { useAsync } from '../lib/hooks'
import { errorText, useApp, useToast } from './AppContext'

export function VocabularySection() {
  const { api } = useApp()
  const toast = useToast()
  const vocab = useAsync(() => api.vocabulary(), [api])
  const [texto, setTexto] = useState('')
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    if (vocab.data) setTexto(vocab.data.terminos.join('\n'))
  }, [vocab.data])

  const terminos = texto
    .split(/[\n,]+/)
    .map((t) => t.trim())
    .filter(Boolean)

  async function save() {
    setBusy(true)
    try {
      const r = await api.setVocabulary(terminos)
      setTexto(r.terminos.join('\n'))
      toast('Vocabulario guardado: se usa desde la próxima reunión')
    } catch (e) {
      toast(errorText(e), 'error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="card stack">
      <h2>Vocabulario</h2>
      <p className="faint" style={{ fontSize: 12.5, marginTop: -6 }}>
        Nombres de personas, empresas, productos o siglas que la transcripción suele escribir mal.
        Uno por línea (hasta 100). Los temas a seguir se suman solos.
      </p>
      <label className="field">
        <span className="sr">Términos del vocabulario</span>
        <textarea
          aria-label="Términos del vocabulario, uno por línea"
          rows={5}
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder={'Fundación Ciudad de Paz\nOKR\nMaximiliano'}
        />
      </label>
      <div className="row">
        <span className="faint grow" style={{ fontSize: 12 }}>
          {terminos.length} {terminos.length === 1 ? 'término' : 'términos'}
          {terminos.length > 100 ? ' · máximo 100' : ''}
        </span>
        <button
          className="btn"
          disabled={busy || terminos.length > 100}
          onClick={() => void save()}
        >
          {busy ? 'Guardando…' : 'Guardar vocabulario'}
        </button>
      </div>
    </section>
  )
}
